module.exports = __webpack_public_path__ + "img/challenge_creativity.ff33d92a.png";